/* eslint semi:0 */
import { BaseStore } from 'stores/baseStore'
import Actions from 'actions/brightcovePlayerActions'

class Queue {

  // IMPORTANT:  this class has been hacked in order to force the autoplay logic
  //             only on the first video enters the viewport, and also to prevent autopause.
  //             when product asks to restore normal autoplay to all videos,
  //             this class should be restored to normal Queue implementation

  constructor() {
    this.list = []
  }

  push(newItem) {
    if (this.list.length === 0) {
      this.list.push(newItem)
    }
  }

  get pick() { return this.list[0] }

  remove(item) {
    // do nothing
  }

}

const VIEWPORT_QUEUE = new Queue()

class BrightcovePlayerStore extends BaseStore {

  get isExternalLoaded() { return !!this.state.isExternalLoaded }

  set isExternalLoaded(flag) { this.state.isExternalLoaded = flag }

  routeAction(action) {
    switch(action.type) {
      case Actions.TYPES.EXTERNAL_LOADED:
        this.isExternalLoaded = true
        this.emitChange()
        break
      case Actions.TYPES.TEMPLATE_READY:
        this.emitChange(action)
        break
      case Actions.TYPES.PLAYER_ENTER_VIEWPORT:
        this.coverPlayerEnterViewport(action.playerId)
        this.emitChange(action)
        break
      case Actions.TYPES.PLAYER_EXIT_VIEWPORT:
        this.coverPlayerExitViewport(action.playerId)
        this.emitChange(action)
        break
    }
  }

  coverPlayerEnterViewport(playerId) { VIEWPORT_QUEUE.push(playerId) }

  coverPlayerExitViewport(playerId) { VIEWPORT_QUEUE.remove(playerId) }

  isCoverPlayerOldestInViewport(playerId) { return this.oldestPlayerInViewport === playerId }

  get oldestPlayerInViewport() { return VIEWPORT_QUEUE.pick }

}

export default BrightcovePlayerStore.create()


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/stores/brightcovePlayerStore.js